import {axiosPut} from "../../main/app-axios";

export const types = {
	APP_ADD_MESSAGE: 'APP_ADD_MESSAGE',
	APP_REMOVE_MESSAGE: 'APP_REMOVE_MESSAGE',
	APP_SHOW_SNACKBAR: 'APP_SHOW_SNACKBAR',
	SET_RELOAD_POPUP: 'SET_RELOAD_POPUP',
};

export const addMessage = (data) => {
	return {
		type: types.APP_ADD_MESSAGE,
		payload: {...data, timestamp: new Date().getTime()}
	}
}

export const removeMessage = (data) => {
	return {
		type: types.APP_REMOVE_MESSAGE,
		payload: data
	}
}

export const showErrorMessages = (errors = []) => dispatch => {
  errors.forEach(it => {
    dispatch(showMessage((it.message instanceof Object ? JSON.stringify(it.message) : it.message), 'error'));
  });
}

export const showMessage = (message, variant = 'success', props = {}) => dispatch => {
  dispatch(addMessage({message, variant, ...props }));
}

export const setReloadPopup = (open, version) => dispatch => {
	dispatch({
		type: types.SET_RELOAD_POPUP,
		payload: { open, version },
	});
}

export const loadData = () => dispatch => {

}

export const atualizarTokeLojaNotification = (loja, token) => async dispatch => {
	console.log(loja, token);
	await axiosPut(`/api/pedidos/stores/token/${loja}`, { token }, dispatch);
}
